import { BriefcaseBusiness } from "lucide-react";

const TileEmployee = ({ data, t }) => {
  const jr = data?.json_response;
  if (!jr?.profile) return null;
  const hasContent =
    jr.headline ||
    jr.name ||
    jr.location ||
    (Array.isArray(jr.experience) && jr.experience.length > 0);
  if (!hasContent) return null;

  const divider = { paddingTop: 12, borderTop: `1px solid ${t.divider}` };
  const iconBox = (bg) => ({
    width: 28,
    height: 28,
    borderRadius: 8,
    background: bg || t.iconBg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  });

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {jr.headline && (
            <p
              style={{
                fontSize: 15,
                fontWeight: 600,
                color: t.textPrimary,
                margin: 0,
                lineHeight: 1.4,
              }}
            >
              {jr.headline}
            </p>
          )}
          {jr.name && (
            <p style={{ fontSize: 13, color: t.textSecondary, margin: 0 }}>
              {jr.name}
            </p>
          )}
          {jr.location && (
            <p
              style={{
                fontSize: 11,
                color: t.textMuted,
                margin: 0,
                marginTop: 2,
              }}
            >
              {jr.location}
            </p>
          )}
        </div>

        {jr.experience?.length > 0 && (
          <div
            style={{
              ...divider,
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            {jr.experience.slice(0, 2).map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", alignItems: "flex-start", gap: 12 }}
              >
                <div
                  style={{ ...iconBox("rgba(139,92,246,0.10)"), marginTop: 2 }}
                >
                  <BriefcaseBusiness
                    size={14}
                    style={{ color: "rgba(139,92,246,0.85)" }}
                    strokeWidth={1.5}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    minWidth: 0,
                  }}
                >
                  {item.title && (
                    <p
                      style={{
                        fontSize: 13,
                        color: t.textPrimary,
                        margin: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item.title}
                    </p>
                  )}
                  {(item.company || item.location) && (
                    <p
                      style={{
                        fontSize: 11,
                        color: t.textMuted,
                        margin: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {[item.company, item.location].filter(Boolean).join(", ")}
                    </p>
                  )}
                  {(item.starts_at?.year || item.ends_at?.year) && (
                    <p
                      style={{
                        fontSize: 11,
                        color: t.textMuted,
                        margin: 0,
                        opacity: 0.7,
                      }}
                    >
                      {item.starts_at?.year ?? ""}
                      {item.starts_at?.year && item.ends_at?.year && " – "}
                      {item.ends_at?.year ?? ""}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TileEmployee;
